<sprout-forms
        *ngIf="form"
        [model]="form"
        (formValue)="onFormValueChange($event, this)">
</sprout-forms>

<div *ngIf="!form" class="alert alert-info">Loading...please wait...</div>
